export default {
    regSeason: {
        standings: [
            {manager:'Taylor', wins: 10, losses: 3, pf: 2423, champ: true},
            {pf: 2035, manager:'Scott', wins: 10, losses: 3},
            {pf: 1868, manager:'Tench', wins: 10, losses: 3},
            {pf: 2139, manager:'Steve', wins: 9, losses: 4},
            {pf: 1979, manager:'Tommy', wins: 8, losses: 5},
            {pf: 1906, manager:'Aidan', wins: 6, losses: 7},
            {pf: 1848, manager:'Kieffer', wins: 6, losses: 7},
            {pf: 1747, manager:'Zane', wins: 6, losses: 7},
            {pf: 1536, manager:'Davis', wins: 4, losses: 9},
            {pf: 1342, manager:'Conor', wins: 4, losses: 9},
            {pf: 1567, manager:'Mike', wins: 3, losses: 10, sacko: true},
            {pf: 1451, manager:'Dan', wins: 2, losses: 11}
        ]
    },
    playoffs: {
        teamData: {
            Taylor: {
                seed: 1
            },
            Scott: {
                seed: 2
            },
            Tench: {
                seed: 3
            },
            Steve: {
                seed: 4
            },
            Tommy: {
                seed: 5
            },
            Aidan: {
                seed: 6
            }
        },
        gameData: [
            {
                name: 'Caleci-Fairlawn-Kennedy Championship Game',
                games: [
                    {
                        Tench: 0,
                        Taylor: 1
                    }
                ],
                props: {
                    winnerIcon: 'trophyGold bi bi-trophy-fill',
                    loserIcon: 'trophySilver bi bi-trophy-fill',
                }
            },
            {
                name: 'Thomas McGrath Award',
                games: [
                    {
                        Steve: 0,
                        Scott: 1
                    }
                ],
                props: {
                    winnerIcon: 'trophyBronze bi bi-trophy-fill',
                }
            },
            {
                name: 'Semifinals',
                games: [
                    {
                        Taylor: 1,
                        Steve: 0
                    },
                    {
                        Scott: 0,
                        Tench: 1
                    }
                ]
            },
            {
                name: 'Wildcard',
                games: [
                    {
                        Steve: 178.06,
                        Tommy: 109.6
                    },
                    {
                        Tench: 154.76,
                        Aidan: 98.12
                    }
                ]
            },
        ]
    },
    draft: {
        order: [
            'Dan',
            'Davis',
            'Tench',
            'Aidan',
            'Conor',
            'Kieffer',
            'Scott',
            'Steve',
            'Tommy',
            'Zane',
            'Mike',
            'Taylor'
        ],
        picks: [
            {pick: 'J. Smith Schuster', manager: 'Dan'}, 
            {pick: 'D. Montgomery', manager: 'Mike'},
            {pick: 'J. Jacobs', manager: 'Mike'},
            {pick: 'D. Williams', manager: 'Davis'},
            {pick: 'K. Galloday', manager: 'Davis'},
            {pick: 'C. Kupp', manager: 'Aidan'},
            {pick: 'AJ Green', manager: 'Tommy'},
            {pick: 'M. Ingram', manager: 'Steve'},
            {pick: 'K. Drake', manager: 'Keiffer'},
            {pick: 'M. Sanders', manager: 'Davis'},
            {pick: 'J. Gordon', manager: 'Davis'},
            {pick: 'D. Henderson', manager: 'Keiffer'},
            {pick: 'D. Johnson', manager: 'Dan'},
            {pick: 'C. Newton', manager: 'Davis'},
            {pick: 'T. Coleman', manager: 'Tench'},
            {pick: 'J. Cook', manager: 'Davis'},
            {pick: 'N. Harry', manager: 'Scott'},
            {pick: 'M.Goodwin', manager: 'Kieffer'},
            {pick: 'D. Samuels', manager: 'Aidan'},
            {pick: 'R. Anderson', manager: 'Conor'},
            {pick: 'D. Njoku', manager: 'Conor'},
            {pick: 'L. Fitzgerald', manager: 'Dan'},
            {pick: 'M. Hardmen', manager: 'Steve'},
            {pick: 'M. Sanu', manager: 'Aidan'},
            {pick: 'D. Metcalf', manager: 'Dan'},
            {pick: 'G. Allison', manager: 'Tommy'},
            {pick: 'D. Thompson', manager: 'Scott'},
            {pick: 'N. Fant', manager: 'Aidan'},
            {pick: 'A. Mattison', manager: 'davis'},
            {pick: 'K. Ballage', manager: 'Scott'},
            {pick: 'D. Pettis', manager: 'Aidan'},
            {pick: 'D. Moncrief', manager: 'Steve'},
            {pick: 'D. Jackson', manager: 'Scott'},
            {pick: 'A. Hooper', manager: 'Tommy'},
            {pick: 'M. Ryan ', manager: 'Zane'},
            {pick: 'D. Parker', manager: 'Scott'},
            {pick: 'L. McCoy', manager: 'Dan'},
            {pick: 'C. Wentz', manager: 'Tommy'},
            {pick: 'D. Singletary', manager: 'Steve'},
            {pick: 'K. Doss', manager: 'Aidan'},
            {pick: 'M. Brown', manager: 'Mike'},
            {pick: 'J. Goff', manager: 'Kieffer'},
            {pick: 'T. Pollard', manager: 'Davis'},
            {pick: 'A. Brown', manager: 'Davis'},
            {pick: 'L. Murray', manager: 'Tommy'},
            {pick: 'M. Breida', manager: 'Tommy'},
            {pick: 'T. Hockenson', manager: 'Mike'},
            {pick: 'B. Roethlisberger', manager: 'Steve'},
            {pick: 'C. Beasley', manager: 'Dan'},
            {pick: 'Bears D ', manager: 'Aidan'},
            {pick: 'D.Brees', manager: 'Tench'},
            {pick: 'H . Butler', manager: 'Aidan'},
            {pick: 'D. Harris', manager: 'Conor'},
            {pick: 'Browns D', manager: 'Kieffer'},
            {pick: 'A. Peterson', manager: 'Scot'},
            {pick: 'J. Jackson', manager: 'Steve'},
            {pick: 'K. Murray', manager: 'Dan'},
            {pick: 'Rams D', manager: 'Zane'},
            {pick: 'Greg Zuerlein', manager: 'Aidan'},
            {pick: 'J. Washington', manager: 'Taylor'},
            {pick: 'M. Andrews', manager: 'Dan'},
            {pick: 'D. Waller', manager: 'Davis'},
            {pick: 'K. Rudolph', manager: 'Tench'},
            {pick: 'E. Ebron', manager: 'Scott'},
            {pick: 'G. Bernard', manager: 'Conor'},
            {pick: 'Jake Elliott', manager: 'Kieffer'},
            {pick: 'L. Jackson', manager: 'Scott'},
            {pick: 'J. Doyle', manager: 'Steve'},
            {pick: 'Jags D', manager: 'Davis'},
            {pick: 'Steve Gostkowski', manager: 'Zane'},
            {pick: 'Bronocos D', manager: 'Mike'},
            {pick: 'D. Thomas', manager: 'Taylor'},
            {pick: 'D. Moore', manager:  'Dan' },
            {pick: 'R. Cobb', manager: 'Mike'},
            {pick: 'F. Gore', manager: 'Aidan'},
            {pick: 'C. Anderson', manager: 'Tommy'},
            {pick: 'P. Cambell', manager: 'Mike'},
            {pick: 'T. Riddick', manager: 'Kieffer'},
            {pick: 'Bills D', manager: 'Scott'},
            {pick: 'Vikings D', manager: 'Steve'},
            {pick: 'P. Richardson', manager: 'Tommy'},
            {pick: 'D. Walker', manager:  'Zane' },
            {pick: 'Harrison Butker', manager: 'Mike'},
            {pick: 'M. Brown', manager: 'Taylor'}
        ]
    }
}